import React, { useMemo } from 'react';
import { styled } from '@tmap/mmm-style-guide/src/styled';
import { toKey, types } from '@tmap/mmm-core/entityKey';
import getPreviewText from '@tmap/mmm-core/slate/getPreviewText';

import 'swiper/css';

import useImpressions, { ImpressionTracker } from '../../hooks/useImpressions';
import LinkCard from '../linkCard';
import UGCDefaultBody from './ugcDefaultBody';
import UGCQuestionBodyWide from './ugcQuestionBodyWide';

const StyledLinkCard = styled(LinkCard)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: theme.palette.common.white,
  height: '100%',
  '&:hover h6': {
    textDecoration: 'underline',
  },
}));

function ContributionCardWide(props) {
  const {
    contribution,
    entityUrl,
    placementId,
    pageId,
    previewTextMaxLen = 300,
    moderationView = false,
    showCardBorder = true,
    squashVerticalPadding = false,
    showPinned = true,
    wantAnswerButton = true,
    showMenuNearText = false,
    showAuthor = true,
    showDate = true,
    showTopics = true,
    allowNonUniformImageHeights = false,
    width,
    lazyProps = {},
    ...otherProps
  } = props;

  const {
    approved,
    type = 'default',
    author,
    content,
  } = contribution;
  const cardLink = (approved || moderationView) ? entityUrl : undefined;

  const impressionMeta = useMemo(() => ({ pageId }), [pageId]);
  const { trackView, trackClick } = useImpressions(
    toKey(types.CONTRIBUTION, contribution._id),
    placementId,
    impressionMeta,
  );

  const authorName = `${author?.firstName} ${author?.lastName}`.trim();
  const previewTextLonger = getPreviewText(content, { maxLength: 400 });
  const previewText = getPreviewText(content, { maxLength: previewTextMaxLen });
  const cardProps = {
    ...props,
    authorName,
    previewText,
    previewTextLonger,
    squashVerticalPadding,
    showPinned,
    wantAnswerButton,
    showMenuNearText,
    showAuthor,
    showDate,
    showTopics,
    allowNonUniformImageHeights,
    width,
    lazyProps,
  };

  switch (type) {
    case 'question':
      return (
        <ImpressionTracker trackView={trackView} trackClick={trackClick}>
          <StyledLinkCard variant={showCardBorder ? 'raised' : 'flush'} href={cardLink} {...otherProps}>
            <UGCQuestionBodyWide {...cardProps} />
          </StyledLinkCard>
        </ImpressionTracker>
      );
    default:
      return (
        <ImpressionTracker trackView={trackView} trackClick={trackClick}>
          <StyledLinkCard variant={showCardBorder ? 'raised' : 'flush'} href={cardLink} {...otherProps}>
            <UGCDefaultBody {...cardProps} />
          </StyledLinkCard>
        </ImpressionTracker>
      );
  }
}

export default ContributionCardWide;
